import CategoryView from "@/pages/category/components/CategoryView";

export default function MovieCategory() {
  return <CategoryView type="movie" />;
}